module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1700.d784afd9.svg";